import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import findIndex from "lodash/findIndex";
import {FormattedMessage} from "react-intl";

import * as actions from '../../../../actions/actionFunctions';

// import {DesignNavigationItem, Layout} from "../core/layout";

export const toggleFilterArrayValue = (array, {filterId, filterGroupId}) => {
  let index = findIndex(array, {filterGroupId});
  if (index >= 0) {
    array[index].filterId === filterId ? array.splice(index, 1) : array.splice(index, 1, {filterId, filterGroupId})
  } else {
    array.push({filterId, filterGroupId});
  }
  return array;
};

export const replaceFilterArrayValue = (array, {filterId, filterGroupId}) => {
  let index = findIndex(array, {filterGroupId});
  if (index >= 0) {
    array.splice(index, 1, {filterId, filterGroupId})
  } else {
    array.push({filterId, filterGroupId});
  }
  return array;
};

const setDefaultFilterArrayValue = (array, filterGroupId) => {
  let index = findIndex(array, {filterGroupId});
  if (index >= 0) {
    array.splice(index, 1);
  }
  return array;
};

class FilterSwitchers extends Component {

  static propTypes = {
    // layout: PropTypes.instanceOf(Layout),
    isMobile: PropTypes.bool,
    activePart: PropTypes.object.isRequired,
    filterGroupName: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      availableFilterValues: [],
      filterGroup: {}
    };
  }

  componentDidMount() {
    this.setAvailableFiltersValues(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activePart && this.props.activePart && nextProps.activePart.partName !== this.props.activePart.partName) {
      this.setAvailableFiltersValues(nextProps);
    }
  }

  componentWillUnmount() {
    this.setDefaultFilterValue();
  }

  setAvailableFiltersValues(nextProps = this.props) {
    const availableFilterValues = [];
    const filterGroup = nextProps.filterGroups.find(group => group.name === nextProps.filterGroupName);
    const fabricatorData = this.props.fabricatorData;
    if (filterGroup) {
      nextProps.activePart.features.forEach((feature) => {
        if (feature.dbFeature.filterValueIDs[filterGroup.id]) {
          feature.dbFeature.filterValueIDs[filterGroup.id].forEach((filterValue) => {
            if (!availableFilterValues.includes(filterValue)) {
              const fValue = filterGroup.values.find(val => val.id === filterValue);
              if (fValue.value === "Slab") {  // we need to look for existing DuraBath Natural Stone features filter
                if (!fabricatorData || (fabricatorData && !fabricatorData.isRebath)) {
                  availableFilterValues.push(filterValue)
                }
              } else if (fValue.value === "DuraBath Natural Stone") {
                if (!fabricatorData || (fabricatorData && fabricatorData.isRebath)) {
                  availableFilterValues.push(filterValue)
                }
              } else {
                availableFilterValues.push(filterValue)
              }
            }
          })
        }
      });
      this.setState({
        availableFilterValues,
        filterGroup
      })
    }
  }

  setActiveFilterValue = (filterId, filterGroupId) => {
    this.props.setSelectedFilters(toggleFilterArrayValue([...this.props.selectedFilters], {filterId, filterGroupId}));
  };

  setDefaultFilterValue = () => {
    this.props.setSelectedFilters(setDefaultFilterArrayValue([...this.props.selectedFilters], this.state.filterGroup.id));
  };

  render() {

    // console.log('parentItem', this.props.parentItem);
    // console.log('activePart', this.props.activePart);
    // console.log('selectedFilters', this.props.selectedFilters);
    // console.log('availableFilterValues:', this.state.availableFilterValues);
    let activeFilterValueId = null;
    if (this.state.availableFilterValues.length && this.state.filterGroup && this.props.selectedFilters.length) {
      const appliedFilter = this.props.selectedFilters.find(filterObj => filterObj.filterGroupId === this.state.filterGroup.id);
      if (appliedFilter) {
        activeFilterValueId = appliedFilter.filterId
      }
    }

    return this.state.availableFilterValues.length ? (
      this.props.isMobile ? (
        <div className="wiz">
          <ul className={"wiz__button-list wiz__button-list--full"}>
            <li className={"wiz__button wiz__button--all"
            + (!activeFilterValueId ? " wiz__button--active" : "")}
                onClick={this.setDefaultFilterValue}>
              <span><FormattedMessage id="filterSelection.allItems"/></span>
            </li>
            {this.state.availableFilterValues.map((filterValueId, index) => {
              const filterValueObject = this.state.filterGroup.values.find(val => val.id === filterValueId);
              return (
                <li className={"wiz__button wiz__button--" + filterValueObject.value.replace(/ /g,"").toLowerCase()
                + (activeFilterValueId === filterValueId ? " wiz__button--active" : "")}
                    key={"filterValue"+index} onClick={() => this.setActiveFilterValue(filterValueId, this.state.filterGroup.id)}>
                  <span>{filterValueObject.value}</span>
                </li>
              )
            })}
          </ul>
        </div>
      ) : (
        <div className="panel-wizard">
          <ul className="panel-wizard-list">
            <li className={"panel-wizard-list__button panel-wizard-list__button--all"
            + (!activeFilterValueId ? " panel-wizard-list__button--active" : "")}
                onClick={this.setDefaultFilterValue}>
              <span className="panel-wizard-list__button-text">
                <FormattedMessage id="filterSelection.allProducts"/>
              </span>
            </li>
            {this.state.availableFilterValues.map((filterValueId, index) => {
              const filterValueObject = this.state.filterGroup.values.find(val => val.id === filterValueId);
              return (
                <li className={"panel-wizard-list__button panel-wizard-list__button--" + filterValueObject.value.replace(/ /g,"").toLowerCase()
                + (activeFilterValueId === filterValueId ? " panel-wizard-list__button--active" : "")}
                    key={"filterValue"+index} onClick={() => this.setActiveFilterValue(filterValueId, this.state.filterGroup.id)}>
                  <span className="panel-wizard-list__button-icon"/>
                  <span className="panel-wizard-list__button-text">{filterValueObject.value}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )
    ) : null
  }
}

const mapStateToProps = (store) => ({
  filterGroups: store.filterState.filterGroups,
  fabricatorData: store.fabricatorState,
  selectedFilters: store.filterState.selectedFilters
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedFilters: (selectedFilters) => dispatch(actions.setSelectedFilters(selectedFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSwitchers);
